import React from 'react'
import { BannerManagementStyled } from './styled'
import {
  Button,
  Modal,
  Image,
  Paginate,
  Section,
  SelectBox,
  Table,
  Switcher,
  Input,
} from '../../components'
import { ICONS, CONTENTS } from '../../themes'
import { ROUTE_PATH, redirect, STRING } from '../../helpers'

export class BannerManagementContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      modals: [{ name: 'delete', isOpen: false, Idlist: '', Fullname: '' }],
      bannerData: [
        { id: '1', isActive: true },
        { id: '2', isActive: true },
        { id: '3', isActive: false },
      ],
      options: [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
      ],
    }
  }

  handleActiveChange = evtID => {
    this.setState(
      prevState => ({
        ...prevState,
        bannerData: prevState.bannerData.map(banner => ({
          ...banner,
          isActive: banner.id === evtID ? !banner.isActive : banner.isActive,
        })),
      })
      // () => {
      //   console.log(this.state.bannerData)
      // }
    )
  }

  toggleModal = (evt, id, name) => {
    this.setState(
      prevState => ({
        ...prevState,
        modals: prevState.modals.map(modal => ({
          ...modal,
          isOpen: modal.name === id ? !modal.isOpen : false,
          Idlist: id,
          Fullname: name,
        })),
      })
      // () => {
      //   console.log(this.state.modals)
      // }
    )
  }

  render() {
    const { modals, bannerData, options } = this.state

    return (
      <React.Fragment>
        <BannerManagementStyled>
          {/* PAGE TITLE
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  id="page_icon_banner_management"
                  src={ICONS['icon-display-star.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section id="page_title_banner_management" className="title">
                  {STRING.BANNER_MANAGEMENT}
                </Section>

                <Section
                  id="page_breadcrumb_banner_management"
                  className="breadcrumbs"
                >
                  <Button
                    className="breadcrumb"
                    onClick={() => {
                      this.props.history.push(ROUTE_PATH.HOME.LINK)
                    }}
                  >
                    <span>{STRING.HOME}</span>
                  </Button>

                  <Button className="breadcrumb current">
                    <span>{STRING.BANNER_MANAGEMENT}</span>
                  </Button>
                </Section>
              </Section>
            </Section>

            <Section className="page-button">
              <Button className="page-button" onClick={() => {}}>
                {/* <Image src={ICONS['icon-add-circular.svg']} alt="add icon" /> */}
                Create Banner
              </Button>
            </Section>
          </Section>

          {/* PAGE CONTENT
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="main-content">
            <Section className="content-body">
              <Section className="table-filter">
                <SelectBox
                  id="active_status_filter"
                  className="table-filter"
                  options={options}
                  placeholder="Active"
                  isSearchable={false}
                  isClearable={true}
                />
              </Section>

              <Section className="table-wrapper">
                <Table className="banner split-row-color">
                  {/* Header Row */}
                  <Table.THEAD>
                    <Table.TR className="header">
                      <Table.TH className="number-order" id="number_id_header">
                        No.
                      </Table.TH>

                      <Table.TH className="image" id="image_header">
                        IMAGE
                      </Table.TH>

                      <Table.TH className="url" id="url_header">
                        URL
                      </Table.TH>

                      <Table.TH className="active" id="active_header">
                        ACTIVE
                      </Table.TH>

                      <Table.TH className="last-update" id="last_update_header">
                        LAST UPDATE
                      </Table.TH>

                      <Table.TH
                        className="created-date"
                        id="create_date_header"
                      >
                        CREATED DATE
                      </Table.TH>

                      <Table.TH className="actions" id="actions_header">
                        ACTIONS
                      </Table.TH>
                    </Table.TR>
                  </Table.THEAD>

                  {/* Content Row */}
                  <Table.TBODY>
                    <Table.TR>
                      <Table.TD className="number-order">1</Table.TD>

                      <Table.TD className="image">
                        <Image src={CONTENTS['banner-thumbnail.png']} />
                      </Table.TD>

                      <Table.TD className="url">
                        <a className="link">
                          www.tspace.co.th/wwwwwwwwwwwwwwwwwwwwwww
                        </a>
                      </Table.TD>

                      <Table.TD className="active">
                        <Switcher
                          onChange={() => this.handleActiveChange('1')}
                          checked={
                            bannerData
                              .filter(banner => {
                                return banner.id === '1'
                              })
                              .map(obj => obj.isActive)[0]
                          }
                        />
                      </Table.TD>

                      <Table.TD className="last-update">
                        Oct 08, 2019 14:00
                      </Table.TD>

                      <Table.TD className="created-date">
                        Oct 08, 2019 14:00
                      </Table.TD>

                      <Table.TD className="actions">
                        <Section>
                          <Button className="link">
                            <Image
                              className="edit-icon"
                              src={ICONS['icon-edit.svg']}
                              alt="edit"
                            />
                          </Button>

                          <Button
                            className="link"
                            onClick={() => this.toggleModal()}
                          >
                            <Image
                              className="delete-icon"
                              src={ICONS['icon-trash.svg']}
                              alt="delete"
                            />
                          </Button>
                        </Section>
                      </Table.TD>
                    </Table.TR>

                    <Table.TR>
                      <Table.TD className="number-order">1</Table.TD>

                      <Table.TD className="image">
                        <Image src={CONTENTS['banner-thumbnail.png']} />
                      </Table.TD>

                      <Table.TD className="url">
                        <a className="link">
                          www.tspace.co.th/wwwwwwwwwwwwwwwwwwwwwww
                        </a>
                      </Table.TD>

                      <Table.TD className="active">
                        <Switcher
                          onChange={() => this.handleActiveChange('2')}
                          checked={
                            bannerData
                              .filter(banner => {
                                return banner.id === '2'
                              })
                              .map(obj => obj.isActive)[0]
                          }
                        />
                      </Table.TD>

                      <Table.TD className="last-update">
                        Oct 08, 2019 14:00
                      </Table.TD>

                      <Table.TD className="created-date">
                        Oct 08, 2019 14:00
                      </Table.TD>

                      <Table.TD className="actions">
                        <Section>
                          <Button className="link">
                            <Image
                              className="edit-icon"
                              src={ICONS['icon-edit.svg']}
                              alt="edit"
                            />
                          </Button>

                          <Button
                            className="link"
                            onClick={() => this.toggleModal()}
                          >
                            <Image
                              className="delete-icon"
                              src={ICONS['icon-trash.svg']}
                              alt="delete"
                            />
                          </Button>
                        </Section>
                      </Table.TD>
                    </Table.TR>

                    <Table.TR>
                      <Table.TD className="number-order">1</Table.TD>

                      <Table.TD className="image">
                        <Image src={CONTENTS['banner-thumbnail.png']} />
                      </Table.TD>

                      <Table.TD className="url">
                        <a className="link">
                          www.tspace.co.th/wwwwwwwwwwwwwwwwwwwwwww
                        </a>
                      </Table.TD>

                      <Table.TD className="active">
                        <Switcher
                          onChange={() => this.handleActiveChange('3')}
                          checked={
                            bannerData
                              .filter(banner => {
                                return banner.id === '3'
                              })
                              .map(obj => obj.isActive)[0]
                          }
                        />
                      </Table.TD>

                      <Table.TD className="last-update">
                        Oct 08, 2019 14:00
                      </Table.TD>

                      <Table.TD className="created-date">
                        Oct 08, 2019 14:00
                      </Table.TD>

                      <Table.TD className="actions">
                        <Section>
                          <Button className="link">
                            <Image
                              className="edit-icon"
                              src={ICONS['icon-edit.svg']}
                              alt="edit"
                            />
                          </Button>

                          <Button
                            className="link"
                            onClick={() => this.toggleModal()}
                          >
                            <Image
                              className="delete-icon"
                              src={ICONS['icon-trash.svg']}
                              alt="delete"
                            />
                          </Button>
                        </Section>
                      </Table.TD>
                    </Table.TR>
                  </Table.TBODY>
                </Table>
              </Section>
            </Section>

            <Section className="content-footer">
              <Section className="showing-item">
                Showing 1 to 10 of 60 entries
              </Section>

              <Section className="paginate-wrapper">
                <Paginate
                  activePage={1}
                  itemsCountPerPage={10}
                  totalItemsCount={450}
                  pageRangeDisplayed={5}
                  // onChange={() => ({})}
                />

                <Section className="moveto-wrapper">
                  <Input
                    className="paginate-moveto"
                    label="Page"
                    defaultValue="1"
                    isHorizontal
                    maxLength="4"
                  />

                  <Button>go</Button>
                </Section>
              </Section>
            </Section>
          </Section>
        </BannerManagementStyled>

        <Modal
          id="delete_id"
          className="theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'delete'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="575px"
        >
          <Modal.Header>Delete</Modal.Header>

          <Modal.Body>
            <p className="default text-center">
              Are you sure to delete? <br />
              {modals[0].FullName}
            </p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              id="close_modal_history_id"
              className="theme-border-gray"
              onClick={() => this.toggleModal('delete')}
            >
              Cancel
            </Button>

            <Button
              id="close_modal_history_id"
              className="theme-green"
              onClick={() => {
                this.deleteList()
              }}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    )
  }
}
